// extracted by mini-css-extract-plugin
export default {"wrap":"EG-z","fullWidth":"FG-z","hideOnDesktop":"GG-z","content":"HG-z","hasOpenedNav":"IG-z","crumbsList":"JG-z","dropdownsWrap":"KG-z"};